import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import Global from 'models/Global';
import MainBaseView from 'views/MainBaseView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import BootstrapData from 'models/BootstrapData';
import { instanaTrackPage } from '@bizzabo/instana-api';
import serviceConfig from 'config';

var MainDownloadAppView = MainBaseView.extend({

    events: {

    },

    initialize: function(options) {
        options = options || {};
        this.bootstrapData = options.bootstrapData;
        FeatureToggleUtils.mergeFeatureToggleWithConfig();
        MainBaseView.prototype.initialize.apply(this, arguments);

        Global.set('page', 'downlaodApp');
        instanaTrackPage('Download App');

        if ($('body').width() < 768) {
            var thisView = this;
            thisView.slidedUp = false;
        }

    }

});

const event = BootstrapData('bootstrap-data-event');
const me = BootstrapData('bootstrap-data-me');
const config = BootstrapData('bootstrap-data-config');
const siteConf = BootstrapData('bootstrap-data-siteConf');
const settings = BootstrapData('bootstrap-data-settings');
const isCookieConsentEnabled = BootstrapData('bootstrap-data-isCookieConsentEnabled');

export default new MainDownloadAppView({
    el: $(document.body),
    bootstrapData: {
        event: event,
        eventID: event.id,
        settings: settings,
        me: me,
        config: config,
        siteConf: siteConf,
        isCookieConsentEnabled
    }
});


